const API_URL = import.meta.env.VITE_API_URL || "https://worker-auth.betalog-ventas.workers.dev";

export interface ApiOptions extends RequestInit {
  skipAuth?: boolean;
}

export const apiService = {
  getToken: (): string | null => localStorage.getItem("clientAccessToken"),
  setToken: (token: string) => localStorage.setItem("clientAccessToken", token),
  removeToken: () => localStorage.removeItem("clientAccessToken"),

  getSessionId: (): string | null => localStorage.getItem("clientSessionId"),
  setSessionId: (id: string) => localStorage.setItem("clientSessionId", id),
  removeSessionId: () => localStorage.removeItem("clientSessionId"),

  getCsrfToken: (): string | null => localStorage.getItem("clientCsrfToken"),
  setCsrfToken: (t: string) => localStorage.setItem("clientCsrfToken", t),
  removeCsrfToken: () => localStorage.removeItem("clientCsrfToken"),

  getClient: (): any | null => {
    const raw = localStorage.getItem("clientUser");
    return raw ? JSON.parse(raw) : null;
  },
  setClient: (c: any) => localStorage.setItem("clientUser", JSON.stringify(c)),
  removeClient: () => localStorage.removeItem("clientUser"),

  clearSession() {
    this.removeToken();
    this.removeSessionId();
    this.removeCsrfToken();
    this.removeClient();
  },

  async fetchWithAuth(path: string, options: ApiOptions = {}): Promise<Response> {
    const fullUrl = path.startsWith("http") ? path : `${API_URL}${path}`;
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...(options.headers as Record<string, string> | undefined),
    };

    if (!options.skipAuth) {
      const token = this.getToken();
      const sessionId = this.getSessionId();
      const csrfToken = this.getCsrfToken();
      if (token) headers["Authorization"] = `Bearer ${token}`;
      if (sessionId) headers["X-Session-Id"] = sessionId;
      if (csrfToken) headers["X-CSRF-Token"] = csrfToken;
    }

    const response = await fetch(fullUrl, { ...options, headers, credentials: "include" });

    if (response.status === 401 && !options.skipAuth) {
      this.clearSession();
    }

    return response;
  },
};